import { pluralize } from 'core/utils/commonUtils';
import { OrderActionEnum } from 'models/enums/orderActionEnum';
import type { DayEvent } from './types';

export const getEventsCount = (day: DayEvent): string => {
  if (day.events.length === 0) {
    return '0 событий';
  }

  const measurementCount = day.events.filter(
    (e) => e.action === OrderActionEnum.Measurement
  ).length;
  const monolithCount = day.events.filter(
    (e) => e.action === OrderActionEnum.Monolith
  ).length;
  const installationCount = day.events.filter(
    (e) => e.action === OrderActionEnum.Installation
  ).length;

  const parts = [];
  if (measurementCount > 0) {
    parts.push(`${pluralize(measurementCount, ['замер', 'замера', 'замеров'])}`);
  }
  if (monolithCount > 0) {
    parts.push(`${pluralize(monolithCount, ['монолит', 'монолита', 'монолитов'])}`);
  }
  if (installationCount > 0) {
    parts.push(
      `${pluralize(installationCount, ['установка', 'установки', 'установок'])}`
    );
  }

  return parts.join(', ');
};
